export const autofillFormatter = (productName: string) => {
    if (!productName) {
        return { shortName: '', productKey: '' };
    }
    const shortName = productName
        .split(/\s+/)
        .map((word) => word && word[0].toUpperCase())
        .join('');

    const productKey = productName.toLowerCase().replace(/\s+/g, '-');

    return { shortName, productKey };
};
